import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Typography, Box, FormControl, IconButton, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddOutlined } from '@mui/icons-material';
import ModalAccountable from './Modals/ModalAccountable';
import ModalDeleteAccountable from './Modals/ModalDeleteAccountable';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import * as actions from '../../../store/actions';

interface IAccountableTenant {
  _id: string;
  name: string;
  email: string;
  role: string;
  phone: string;
}

interface IAccountable {
  _id: string;
  name: string;
  email: string;
}


const TenantAccountables = (props: any) => {
  const dispatch = useDispatch();

  const tenant = useSelector((state: any) => state.tenants.tenant);
  const loadingTenant = useSelector((state: any) => state.tenants.loading);

  const gapUsersForOptions = useSelector((state: any) => state.tenants.gapUsersForOptions);
  const loadingGapUsersForOptions = useSelector((state: any) => state.tenants.loadingGapUsersForOptions);

  const [openAddEditModal, setOpenAddEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [accountablesTenant, setAccountablesTenant] = useState<IAccountableTenant[]>([]);
  const [selectedAccountableTenant, setSelectedAccountableTenant] = useState<IAccountableTenant>();

	const [searchTextAccountable, setSearchTextAccountable] = useState<string>('');
	const [accountablesFormated, setAccountablesFormated] = useState<IAccountable[]>([]);
	const [accountables, setAccountables] = useState<Array<{ value: string; name: string; }>>([]);

  const fetchGapUsersForOptions = useCallback(
    () => dispatch(actions.fetchGapUsersForOptions(1, 100, searchTextAccountable, 'asc', 'name')),
    [searchTextAccountable]
  );

  useEffect(() => {  
    if (props.match.params.id !== 'new' && tenant) {
      setAccountables(tenant?.accountables?.map((obj: IAccountable) => ({ value: obj._id, label: obj.name })) || []);
      setAccountablesTenant(tenant?.accountablesTenant || []);
    } else {
      setAccountables([]);
      setAccountablesTenant([]);
    }
  }, [tenant])

  useEffect(() => {
    props.setAccountablesForBody(accountables.map(obj => obj.value));
  }, [accountables])

  useEffect(() => {
    props.setAccountablesTenantForBody(accountablesTenant.map(({ name, role, email, phone }) =>({ name, role, email, phone })));
  }, [accountablesTenant])


	useEffect(() => {
		fetchGapUsersForOptions();
	}, [searchTextAccountable]);


	useEffect(() => {
		setAccountablesFormated(
			gapUsersForOptions.rows.map((accountable: IAccountable) => ({ value: accountable._id, label: accountable.name, ...accountable }))
		)
	}, [gapUsersForOptions])



	const handleInputChangeAccountables = (selected: IAccountable[]) => {
		if(selected) {
			setAccountables(
				selected.map(dt => ({ value: dt._id, label: dt.name, ...dt }))
			);
		} else {
			setAccountables([]);
		}
	}


	const handleInputChangeSelectorSites = (text: string) => {
		setSearchTextAccountable(text);
	}

  const addEditAccountableTenant = (accountable: IAccountableTenant) => {
    setAccountablesTenant(prev => {
      const index = prev.findIndex(obj => obj._id === accountable._id);

      if (index > -1) {
        return [
          ...prev.slice(0, index),
          accountable,
          ...prev.slice(index + 1)
        ]
      }

      return [...prev, accountable];
    })
  }

  const deleteAccountableTenant = () => {
    if (!selectedAccountableTenant) return;

    setAccountablesTenant(prev => {
      const index = prev.findIndex(obj => obj._id === selectedAccountableTenant._id);

      if (index > -1) {
        return [
          ...prev.slice(0, index),
          ...prev.slice(index + 1)
        ]
      }

      return prev;
    })
  }

  const AccountableCard = ({ accountable }: { accountable: IAccountableTenant }) => {
    const { name, email, phone, role } = accountable;

    return (
      <Box sx={{display: 'flex', flexDirection: 'row',  background: '#eee', borderRadius: '5px', padding: '8px 16px', justifyContent: 'space-between'}}>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'stretch'}}>
          <Typography>{name}</Typography>
          <Typography>{phone}</Typography>
          <Typography>{email}</Typography>
          <Typography>{role}</Typography>
        </Box>
        {(props.isNewData || props.editMode) && (
          <Box>
            <IconButton onClick={() => { setSelectedAccountableTenant(accountable); setOpenAddEditModal(true); }} size="small"><EditIcon /></IconButton>
            <IconButton onClick={() => { setSelectedAccountableTenant(accountable); setOpenDeleteModal(true); }} size="small"><DeleteIcon /></IconButton>
          </Box>
        )}
      </Box>
    )
  }


  const restoreValues = () => {
    if (props.match.params.id !== 'new' && tenant) {
      setAccountables(tenant?.accountables?.map((obj: IAccountable) => ({ value: obj._id, label: obj.name })) || []);
      setAccountablesTenant(tenant?.accountablesTenant || []);
    } else {
      setAccountables([]);
      setAccountablesTenant([]);
    }
  }

  return <>
    <ModalAccountable
      open={openAddEditModal}
      onClose={() => { setOpenAddEditModal(false); setSelectedAccountableTenant(undefined); } }
      onSubmit={addEditAccountableTenant}
      accountable={selectedAccountableTenant}
    />
    <ModalDeleteAccountable
      open={openDeleteModal}
      onClose={() => { setOpenDeleteModal(false); setSelectedAccountableTenant(undefined); } }
      onSubmit={deleteAccountableTenant}
    />        

    <Box>
      <FormControl variant="standard" fullWidth margin='normal'>
        <Autocomplete
          disabled={!props.isNewData && !props.editMode}
          placeholder={(!props.isNewData && !props.editMode) ? 'Não possui responsáveis GAP Sistemas' : 'Selecione os responsáveis'}
          loading={loadingGapUsersForOptions}
          label="Responsáveis GAP Sistemas"
          data={accountablesFormated}
          onSelectValue={handleInputChangeAccountables}
          valueSelected={accountables}
          newSearchText={handleInputChangeSelectorSites}
          id="accountables"
          isMulti
        />
      </FormControl>

      <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'stretch', marginTop: '20px'}}>
          <Typography>Responsáveis Tenant</Typography>
          {accountablesTenant.length === 0 && <Typography>Não possui responsáveis</Typography>}
          {accountablesTenant.map((obj, index) => <AccountableCard key={index} accountable={obj} />)}
          {(props.isNewData || props.editMode) && (
            <Box sx={{width: '100%', textAlign: 'left'}}>
              <Button
                startIcon={<AddOutlined />}
                variant="text"
                disabled={loadingTenant}
                onClick={() => setOpenAddEditModal(true)}
              >
                Adicionar
              </Button>
            </Box>
          )}
      </Box>
    </Box>
  </>;
}

export default withRouter(TenantAccountables);

